import { useState } from "react";
import CRMSidebar from "./CRMSidebar";
import { FiSettings } from "react-icons/fi";
import CRMAnalytics from "./Analytics/CRMAnalytics";
import FormManagement from "./FormManagement/FormManagement";

const CRMManagement = () => {
  const [openCRMModules, setOpenCRMModules] = useState("crmAnalytics");

  return (
    <>
      <aside className="channels-panel border-end">
        <div className="channels-header pt-3 px-2">
          <strong>Work Bridge</strong>
          <FiSettings />
        </div>
        <CRMSidebar
          setOpenCRMModules={setOpenCRMModules}
          openCRMModules={openCRMModules}
        />
      </aside>
      <div className="chat-wrapper">
        <div className="chat-main">
          {openCRMModules === "crmAnalytics" && <CRMAnalytics />}
          {openCRMModules === "crmForm" && <FormManagement />}
        </div>
      </div>
    </>
  );
};

export default CRMManagement;
